import React, { useState } from 'react';

const ImportProductInput = ({ onImport }) => {
  const [url, setUrl] = useState('');

  const handleInputChange = (e) => {
    setUrl(e.target.value);
  };

  const handleImportClick = () => {
    if (url.trim()) {
      onImport(url);
      setUrl(''); // Clear input after initiating import
    }
  };

  return (
    <div className=" flex items-center gap-2 text-[#C58348] ">
      <input
        type="text"
        value={url}
        onChange={handleInputChange}
        placeholder="Paste product URL here..."
        className="text-[#2D1735] flex-grow bg-white/50 border border-[#5F40A1]/50 rounded px-4 py-2"
      />
      <button
        onClick={handleImportClick}
        className="bg-[#5F40A1] text-[#E9A969] px-6 py-2 rounded-full hover:bg-[#4709CB] font-semibold shadow-md"
      >
        import
      </button>
    </div>
  );
};

export default ImportProductInput;